module.exports = __webpack_public_path__ + "img/gift.a4763f18.png";